import React from 'react';
import {
  QueryClient,
  QueryClientProvider as TanStackQueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import env from 'env';
import { MAX_VALUE } from 'data/global';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: MAX_VALUE,
    },
  },
});

const QueryClientProvider: React.FC = ({ children }) => (
  <TanStackQueryClientProvider client={queryClient}>
    {children}
    {env.SHOW_REACT_QUERY_DEVTOOL && (
      <ReactQueryDevtools initialIsOpen={false} />
    )}
  </TanStackQueryClientProvider>
);

export default QueryClientProvider;
